import { h } from 'preact';

import { getLabel } from '../../../../labels/labelling-service';
import SelectBox from '../../../components/3-molecules/select-box/select-box';
import SkyItBox from '../../../components/3-molecules/sky-it-box/sky-it-box';
import { parseParselyPrefsForSelectBox } from '../../../utils/parsers';

export const renderPreferencesFollowed = (allUserPreferences) => {
  const selectBoxesModifiers = ['2-cols', '3-cols-tablet', '5-cols-desktop', 'no-border'];
  return (
    <SkyItBox title={getLabel('you.are.following.title')}>
      <SelectBox
        modifiers={selectBoxesModifiers}
        options={parseParselyPrefsForSelectBox({
          preferences: allUserPreferences,
          areActive: true,
          areFollowed: true,
        })}
      />
    </SkyItBox>
  );
};
